import { Link } from "@tanstack/react-router";

export function SiteFooter() {
  return (
    <footer className="border-t border-border/60 py-8">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-5 text-xs text-muted-foreground sm:flex-row sm:justify-between">
        <span>
          © {new Date().getFullYear()} shopify-freelancer.net, Shopify Freelancer für Shopaufbau,
          Anpassungen, Entwicklung und Conversion-Optimierung. Unabhängiger Dienstleister,
          nicht der offizielle Shopify-Support.
        </span>
        <nav className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/leistungen" className="hover:text-foreground">Leistungen</Link>
          <Link to="/shopify-freelancer" className="hover:text-foreground">Shopify Freelancer</Link>
          <Link to="/shopify-shop-erstellen-lassen" className="hover:text-foreground">Shop erstellen lassen</Link>
          <Link to="/shopify-theme-anpassung" className="hover:text-foreground">Theme-Anpassung</Link>
          <Link to="/shopify-conversion-optimierung" className="hover:text-foreground">Conversion-Optimierung</Link>
          <Link to="/shopify-entwickler" className="hover:text-foreground">Shopify Entwickler</Link>
          <Link to="/shopify-support" className="hover:text-foreground">Shopify Support</Link>
          <Link to="/shopify-beratung" className="hover:text-foreground">Shopify Beratung</Link>
          <Link to="/shopify-plus" className="hover:text-foreground">Shopify Plus</Link>
          <Link to="/shopify-seo" className="hover:text-foreground">Shopify SEO</Link>
          <Link to="/cases" className="hover:text-foreground">Kunden</Link>
          <Link to="/roi-rechner" className="hover:text-foreground">Conversion-Rechner</Link>
          <Link to="/ratgeber" className="hover:text-foreground">Ratgeber</Link>
          <Link to="/blog" className="hover:text-foreground">Blog</Link>
          <Link to="/fragen" className="hover:text-foreground">Fragen</Link>
          <Link to="/partner-werden" className="hover:text-foreground">Partner werden</Link>
          <Link to="/faq" className="hover:text-foreground">FAQ</Link>
          <Link to="/kontakt" className="hover:text-foreground">Kontakt</Link>
          <Link to="/impressum" className="hover:text-foreground">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-foreground">Datenschutz</Link>
        </nav>
        <nav className="mt-4 flex flex-wrap items-center justify-center gap-3 text-xs">
          <span className="text-muted-foreground/70">Shopify Freelancer in:</span>
          <Link to="/shopify-freelancer/$city" params={{ city: "berlin" }} className="hover:text-foreground">Berlin</Link>
          <Link to="/shopify-freelancer/$city" params={{ city: "muenchen" }} className="hover:text-foreground">München</Link>
          <Link to="/shopify-freelancer/$city" params={{ city: "hamburg" }} className="hover:text-foreground">Hamburg</Link>
          <Link to="/shopify-freelancer/$city" params={{ city: "koeln" }} className="hover:text-foreground">Köln</Link>
          <Link to="/shopify-freelancer/$city" params={{ city: "frankfurt-am-main" }} className="hover:text-foreground">Frankfurt</Link>
          <Link to="/shopify-freelancer/$city" params={{ city: "duesseldorf" }} className="hover:text-foreground">Düsseldorf</Link>
          <Link to="/shopify-freelancer/$city" params={{ city: "stuttgart" }} className="hover:text-foreground">Stuttgart</Link>
          <Link to="/shopify-freelancer/$city" params={{ city: "wien" }} className="hover:text-foreground">Wien</Link>
        </nav>
      </div>
    </footer>
  );
}
